<div class="schedule-wrapper">
  <div class="row">
    <div class="col-xs-12 col-lg-3">
      <h3>Scheduler</h3>
    </div>
    <div class="col-xs-12 col-lg-9 text-right">
      <div class="btn-group  pull-right">
        <button type="button" [ngClass]="{'btn':true,'btn-primary':true, 'active':((scheduleFilter | async)?.selectedView == schViews.calendar)}" (click)="calendarClick()">Calendar</button>
        <button type="button" [ngClass]="{'btn':true,'btn-primary':true, 'active':((scheduleFilter | async)?.selectedView !== schViews.calendar)}" (click)="ganttClick()">Gantt</button>
      </div>
      <div class="pull-right" style="padding-right:5px;">
        <button class="btn btn-default" (click)="addNewScheduleItem()">New Schedule Item</button>
      </div>
      <div class="input-group pull-right" style="width:150px; padding-right:5px;">
        <input type="text" class="form-control" placeholder="Enter SI#" [(ngModel)]="siNum" (keyup.enter)="clickGoSI()">
        <span class="input-group-btn">
          <button class="btn btn-primary" (click)="clickGoSI()" type="button">Go!</button>
        </span>
      </div>
      <div class="input-group pull-right" style="width:150px; padding-right:5px;">
        <input type="text" class="form-control" placeholder="Enter TR#" [(ngModel)]="trNum" (keyup.enter)="clickGoTR()">
        <span class="input-group-btn">
          <button class="btn btn-primary" (click)="clickGoTR()" type="button">Go!</button>
        </span>
      </div>
    </div>
  </div>
  <hr style="margin-top:5px;margin-bottom:5px;" />
  <div class="row">
    <div class="col-xs-12 text-right">
      <span>
        <a style="cursor:pointer" (click)="clearFilter()">
          Clear Filter
        </a> &nbsp;
      </span>
      Show Only:
      <mat-button-toggle-group #group="matButtonToggleGroup" multiple style="margin-right: 15px;">
        <mat-button-toggle
          [checked]="curSF.onlySitePositions"
          (change)="curSF.onlySitePositions = !curSF.onlySitePositions; pushNext()">
          Site Pos
        </mat-button-toggle>
        <mat-button-toggle
          [checked]="curSF.onlyEmp"
          (change)="curSF.onlyEmp = !curSF.onlyEmp; pushNext()">
          Employee
        </mat-button-toggle>
        <mat-button-toggle
          [checked]="curSF.onlyNonEmp"
          (change)="curSF.onlyNonEmp = !curSF.onlyNonEmp; pushNext()">
          Non-Employee
        </mat-button-toggle>
        <mat-button-toggle
          [checked]="curSF.onlyBilleting"
          (change)="curSF.onlyBilleting = !curSF.onlyBilleting; pushNext()">
          Billeting
        </mat-button-toggle>
        <mat-button-toggle
          [checked]="curSF.onlyTraining"
          (change)="curSF.onlyTraining = !curSF.onlyTraining; pushNext()">
          Training
        </mat-button-toggle>
        <mat-button-toggle
          [checked]="curSF.onlyFlights"
          (change)="curSF.onlyFlights = !curSF.onlyFlights; pushNext()">
          Flights
        </mat-button-toggle>
        <mat-button-toggle title="Pending Approval"
          [checked]="curSF.onlyPending"
          (change)="curSF.onlyPending = !curSF.onlyPending; pushNext()">
          Pending
        </mat-button-toggle>
        <mat-button-toggle title="O&A / COPA"
          [checked]="curSF.onlyOandA"
          (change)="curSF.onlyOandA = !curSF.onlyOandA; pushNext()">
          O&A/COPA
        </mat-button-toggle>
      </mat-button-toggle-group>

      <mat-label>Name:</mat-label>
      <mat-form-field appearance="fill" class="form-component" class="editable-text-field" style="margin-left: 20px;" >
        <input #nameInput matInput type="text" />
      </mat-form-field>
      &nbsp;
      Job Title:

       <mat-form-field appearance="fill">
          <mat-select
            name="Job Title"
            [(ngModel)]="curSF.jobTitleId"
            (selectionChange)="updateFilter()" >
              <mat-option></mat-option>
              <mat-option *ngFor="let j of jobTitleValues | async" [value]="j.jobTitleId">
                  {{ j.jobTitle }}
              </mat-option>
          </mat-select>
        </mat-form-field>
      &nbsp; || &nbsp;
      Site:
      <mat-form-field appearance="fill">
        <mat-select
          name="Site"
          [(ngModel)]="curSF.siteId"
          (selectionChange)="siteChange($event.value)" >
            <mat-option></mat-option>
            <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                {{ s.siteName }}
            </mat-option>
        </mat-select>
      </mat-form-field>

      &nbsp;Company Only:&nbsp;
        <mat-checkbox
          title="Company/SAN sites Only?"
          name="Company"
          [(ngModel)]="companySitesOnly"
          (change)="handleCompanySitesOnlyChecked()"
          tabindex="-1"
          >
        </mat-checkbox>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 text-right" >
      <ng-container *ngIf="(scheduleFilter | async)?.selectedView !== schViews.calendar">
        Show:
        <mat-form-field appearance="fill">
          <mat-select
            name="Gantt Views"
            [(ngModel)]="curSF.selectedView"
            (selectionChange)="updateFilter()" >
              <mat-option *ngFor="let s of ganttViews" [value]="s">
                  {{ s.text }}
              </mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;
      </ng-container>
      <ng-container *ngIf="(scheduleFilter | async)?.selectedView == schViews.week || (scheduleFilter | async)?.selectedView == schViews.twoWeeks || (scheduleFilter | async)?.selectedView == schViews.day">
        From: <div class="btn-group">
          <button type="button" class="btn btn-primary" (click)="dateMove('back')"><<</button>
          <button type="button" class="btn btn-primary disabled">{{ m((scheduleFilter | async)?.dateRange.start).format('MM/DD/YYYY') }}</button>
          <button type="button" class="btn btn-primary" (click)="dateMove('forward')">>></button>
        </div>&nbsp;
      </ng-container>

      <ng-container *ngIf="(scheduleFilter | async)?.selectedView == schViews.calendar || (scheduleFilter | async)?.selectedView == schViews.month || (scheduleFilter | async)?.selectedView == schViews.threeMonths">
        Month:
         <mat-form-field appearance="fill">
          <mat-select
            name="Month"
            [(ngModel)]="curSF.month"
            (selectionChange)="updateMonth()" >
              <mat-option *ngFor="let m of months" [value]="m.number"> {{ m.name }} </mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;
      </ng-container>

      Year:
        <mat-form-field appearance="fill">
          <mat-select
            name="Year"
            [(ngModel)]="year"
            (selectionChange)="yearChange($event.value)" >
              <mat-option *ngFor="let y of years" [value]="y"> {{ y }} </mat-option>
          </mat-select>
        </mat-form-field>

      &nbsp;
      <button (click)="goToToday()">Today</button>
    </div>
  </div>
  <div class="row top10" *ngIf="(data | async) && showSch; else awaitingData">
    <ng-container *ngIf="scheduleFilter | async as filter">
      <div *ngIf="filter.selectedView !== schViews.calendar" class="col-xs-9">
        <aims-scheduler-gantt #ganttView="schedulerGanttView" (ganttDateClick)="ganttDateClick($event)" (nameSelected)="updateName($event)" (scheduleItemSelected)="setSchItem($event)" [peopleScheduled]="peopleScheduled" [filter]="filter"></aims-scheduler-gantt>
      </div>
      <div *ngIf="filter.selectedView == schViews.calendar" class="col-xs-9">
        <aims-scheduler-calendarview #calendarView="schedulerCalendarView" (daySelected)="calendarDaySelected.next($event)" [data]="daysOfMonth | async"></aims-scheduler-calendarview>
      </div>
      <div class="col-xs-3">
        <aims-scheduler-detailview [detailView]="detailView | async" (linkClicked)="setSchItem($event)"></aims-scheduler-detailview>
      </div>
    </ng-container>
  </div>

</div>

<ng-template #awaitingData>
  <aims-spinner [spinnerText]="'Loading Schedule...'" [showSpinner]="true"></aims-spinner>
</ng-template>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
